import axios from 'axios';

import { getUrlContext, getCurrentLanguage } from '@/helpers/AppHelpers';

let listeQuestionsReponses = [];
let listeQuestionOrdre = [];

export default {
  async getQuestionsReponses(idRubriqueAide = null) {
    const uuid = idRubriqueAide ? idRubriqueAide.join('|') : null;

    await axios
      .get(getUrlContext(process.env.VUE_APP_REST_JEL.replace('CONTENT_APP', 'aide')), {
        params: {
          'jcr:uuid': uuid,
          lang: getCurrentLanguage(),
        },
      })
      .then((response) => fillQuestionList(response, idRubriqueAide, uuid))
      .catch(() => {
        listeQuestionsReponses = [];
      });

    return listeQuestionsReponses;
  },
};

function fillQuestionList(response, idRubriqueAide, uuid) {
  listeQuestionsReponses = [];
  listeQuestionOrdre = [];
  // eslint-disable-next-line array-callback-return
  response.data.results.map(function (aide) {
    if ((uuid !== '' && idRubriqueAide) || (aide.indFAQ === 'true' && !idRubriqueAide)) {
      listeQuestionsReponses.push({
        id: aide['@id'],
        name: aide.name,
        question: aide.question,
        reponse: aide.reponse,
        dateDebutNouveaute: aide.dateDebutNouveaute,
        dateFinNouveaute: aide.dateFinNouveaute,
      });
    }
  });

  if (idRubriqueAide) {
    listeQuestionsReponses = trierQuestions(idRubriqueAide, listeQuestionsReponses);
  }
}

function trierQuestions(idRubriqueAide, listeQuestionsReponses) {
  let indexFind;

  for (let i = 0; i < idRubriqueAide.length; i++) {
    indexFind = listeQuestionsReponses.find((elementQR) => elementQR.id === idRubriqueAide[i]);
    if (indexFind.id === idRubriqueAide[i]) {
      listeQuestionOrdre.push({
        id: indexFind.id,
        name: indexFind.name,
        question: indexFind.question,
        reponse: indexFind.reponse,
        dateDebutNouveaute: indexFind.dateDebutNouveaute,
        dateFinNouveaute: indexFind.dateFinNouveaute,
      });
    }
  }
  listeQuestionsReponses = listeQuestionOrdre;
  return listeQuestionsReponses;
}
